import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatTreeModule } from '@angular/material/tree';
import { OnboardingPermissionsTreeComponent } from '@modules/shared/components/onboarding-permissions-tree/onboarding-permissions-tree.component';
import { ShowProcessModule } from '@modules/shared/components/show-process/show-process.module';

@NgModule({
	declarations: [OnboardingPermissionsTreeComponent],
	exports: [OnboardingPermissionsTreeComponent],
	imports: [
		ReactiveFormsModule,
		MatRadioModule,
		MatTreeModule,
		CommonModule,
		MatIconModule,
		MatButtonModule,
		MatCheckboxModule,
		ShowProcessModule,
	],
})
export class OnboardingPermissionsTreeModule {}
